<template>
    <discount-pix v-if="pixPriceProduct"
    >
        no PIX por <span>{{ pixPriceProduct }}</span>
    </discount-pix>
</template>

<script>
import {getDiscountPix} from '../../services/product'
import Currency from '../../helpers/parseCurrency'
import { mapState } from 'vuex'
import { CDiscountPix } from '../Styles/Product/styled';

export default {
    name: 'DiscountPix',
    props: {
        product: {
            default: null
        }
    },
    components: {
        'discount-pix': CDiscountPix
    },
    data() {
        return {
            currency: Currency
        }
    },
    methods: {
        discountPix() {
            return getDiscountPix(this.company)
        }
    },
    computed: {
        ...mapState("company", [
            "company"
        ]),
        basePriceProduct() {
            return parseFloat(this.product?.price_to ?? this.product?.from_price_site ?? this.product?.pro_price_site ?? 0)
        },
        pixPriceProduct() {
            if (!this.discountPix() || !this.basePriceProduct) {
                return null
            }

            const priceWithPixDiscount = this.basePriceProduct - (
                this.basePriceProduct * this.discountPix() / 100
            )

            return this.currency.money(priceWithPixDiscount)
        }
    }
}
</script>

<style>

</style>
